import React from 'react'
import "./Navbar.css"
import { Link } from 'react-router-dom'
export default function Navbar() {
  return (
    <>
    <nav className="navbar navbar-expand-lg bg-light p-4 position-fixed w-100">
  <div className="container">
    <a id="logo" className="navbar-brand" href="#">DeepPay</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto  mb-lg-0 w-100 d-flex align-items-lg-center align-items-start justify-content-end">
        <li className="nav-item">
          <Link to={"/"} className="nav-link active" aria-current="page" href="#">Home</Link>
        </li>
        <li className="nav-item ">
        <Link to={"/services"} className="nav-link active" aria-current="page" href="#">Services</Link>
      </li>
      <li className="nav-item  ">
      <Link to={"/contact"} className="nav-link active" aria-current="page" href="#">Contact</Link>
    </li>
    <li className="nav-item ">
    <Link to={"/about"} className="nav-link active" aria-current="page" href="#">About</Link>
  </li>
  <form action="" className='d-flex'>
  <button className='btn-style' type='submit'>Sign up</button>
  <button className='btn-style' type='submit'>Login</button>
  </form>
      </ul>
    </div>
  </div>
</nav>
    </>
  )
}
